import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';

import { APP_CONFIG } from '@core/common-legacy';
import type {
  TellentAdminAppConfig,
  TellentAppKindParam,
  TellentAppRouteID,
  TellentPageConfig,
} from '@core/tellent-types';
import { ORG_GUID } from '@core/tellent-types';

export function injectTellentAppUrlOpener() {
  const config = inject<TellentAdminAppConfig>(APP_CONFIG);
  const doc = inject(DOCUMENT);
  const _orgGuid = inject(ORG_GUID) ?? undefined;

  return (
    kind: TellentAppKindParam,
    pageConfig?: TellentPageConfig<TellentAppRouteID>,
    orgGuid: string | undefined = _orgGuid,
    target: string = '_self',
  ) => doc.defaultView?.open(buildUrl(config.tellentAuthUrl, kind, pageConfig, orgGuid), target);
}

export function injectTellentAppUrlBuilder() {
  const config = inject<TellentAdminAppConfig>(APP_CONFIG);
  return (
    kind: TellentAppKindParam,
    pageConfig?: TellentPageConfig<TellentAppRouteID>,
    orgGuid?: string,
  ) => buildUrl(config.tellentAuthUrl, kind, pageConfig, orgGuid);
}

function buildUrl<ID extends TellentAppRouteID>(
  base: string,
  kind: TellentAppKindParam,
  pageConfig?: TellentPageConfig<ID>,
  orgGuid?: string | null,
) {
  let url = `${base}/switch?app_kind=${kind}`;

  if (orgGuid) {
    url += `&org_guid=${orgGuid}`;
  }

  if (pageConfig) {
    url += `&page=${encodeURIComponent(JSON.stringify(pageConfig))}`;
  }

  return url;
}
